import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SelectionBoxElement = styled.div`
  width: ${props => props.mobileWidth};
  height: ${props => props.height};
  border-radius: ${props => props.borderRadius};
  border: solid ${props => props.borderWidth} ${props => (props.active) ? props.activeColor : props.borderColor};
  color: ${props => (props.active) ? props.activeColor : props.textColor}
  margin-right: ${props => props.mobileMarginRight};
  margin-bottom: ${props => props.mobileMarginBottom};
  text-align:center;
  padding: 10px 0;
  font-size: ${props => props.fontSize};
  display: inline-block;
  &:hover {
    cursor: pointer
  }

  @media(min-width: 800px) {
    width: ${props => props.width};
    margin-right: ${props => props.marginRight};
    margin-bottom: ${props => props.marginBottom};
  }
`;

SelectionBoxElement.propTypes = {
  mobileWidth: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  borderWidth: PropTypes.string,
  borderColor: PropTypes.string,
  activeColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  marginRight: PropTypes.string,
  marginBottom: PropTypes.string,
  mobileMarginRight: PropTypes.string,
  mobileMarginBottom: PropTypes.string,
};

SelectionBoxElement.defaultProps = {
  mobileWidth: "65px",
  width: "88px",
  height: "44px",
  borderRadius: "4px",
  borderWidth: "1px",
  borderColor: "#e9eff4",
  activeColor: "#28b899",
  textColor: "#303030",
  fontSize: "14px",
  marginRight: "12px",
  marginBottom: "20px",
  mobileMarginRight: "12px",
  mobileMarginBottom: "20px",
};

export default SelectionBoxElement;


// WEBPACK FOOTER //
// ./src/components/UI/SelectionBox/SelectionBoxElement.js